import React, { useContext } from 'react'
import styled from 'styled-components'
import Swiper from 'react-id-swiper'
import 'swiper/css/swiper.css'
import { LayoutContext } from '../../contexts'
import { SiteLink } from '../shared/SiteLink'
import { useCollectionClickedTracking } from '../../hooks/tracking'
import { getAvailable } from '../../utils'
import { Icon } from '../shared/Icon'
import { useIsMobile } from '../../hooks/useIsMobile'

const CollectionSwitcherAlt = ({
  collections,
  currentCollection,
  location,
}) => {
  const isMobile = useIsMobile()
  const { node_locale, currency } = useContext(LayoutContext)
  const availableLinks = collections.links.filter(getAvailable)

  const getSelectedIndex = () => {
    let selectedIndex = 0
    availableLinks?.forEach(({ target: { slug } }, index) => {
      if (currentCollection === slug) selectedIndex = index
    })
    return selectedIndex
  }

  const params = {
    navigation: {
      nextEl: '.swiper-button-black.swiper-button-next',
      prevEl: '.swiper-button-black.swiper-button-prev ',
      disabledClass: 'swiper-button-disabled',
    },
    spaceBetween: 16,
    slidesPerView: 4,
    centeredSlides: true,
    centeredSlidesBounds: true,
    initialSlide: getSelectedIndex(),
  }

  return (
    <CollectionListContainer>
      {isMobile ? (
        <StyledSwiper>
          <Swiper {...params}>
            {availableLinks.map(({ title, target: { slug } }, index) => {
              return (
                <Slide
                  key={title}
                  selected={currentCollection === slug}
                  className={`alt-item ${
                    currentCollection === slug ? 'selected' : ''
                  }`}
                  data-position={index}
                >
                  <CollectionListLink
                    to={slug}
                    onClick={() =>
                      useCollectionClickedTracking({
                        currency: currency?.code,
                        locale: node_locale,
                        name: title,
                        label: title,
                        linkType: 'Link',
                        sectionType: 'Collection Switcher Mobile',
                        destination: `/${node_locale}/${slug}/`,
                      })
                    }
                    state={{ referrer: location.pathname }}
                  >
                    {title}
                  </CollectionListLink>
                </Slide>
              )
            })}
          </Swiper>
        </StyledSwiper>
      ) : (
        <CollectionList>
          {availableLinks.map(({ title, target: { slug } }) => (
            <CollectionListItem
              key={title}
              selected={currentCollection === slug}
              className={`alt-item ${
                currentCollection === slug ? 'selected' : ''
              }`}
            >
              <CollectionListLink
                to={slug}
                onClick={() =>
                  useCollectionClickedTracking({
                    currency: currency?.code,
                    locale: node_locale,
                    name: title,
                    label: title,
                    linkType: 'Link',
                    sectionType: 'Collection Switcher Desktop',
                    destination: `/${node_locale}/${slug}/`,
                  })
                }
                state={{ referrer: location.pathname }}
              >
                {title}
              </CollectionListLink>
            </CollectionListItem>
          ))}
        </CollectionList>
      )}
    </CollectionListContainer>
  )
}

const CollectionListContainer = styled.div`
  position: relative;
  width: 100%;
  /* height: fit-content; */
  /* scrollbar-width: none; */

  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    /* overflow-y: scroll; */
    margin-bottom: ${(props) => props.theme.space.marginMobile / 4}rem;
  }
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: block;
    width: 100vw;
  }
`

const CollectionList = styled.ul`
  display: inline-flex;
  align-items: center;
  overflow-y: visible;

  /* @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding-top: ${(props) => props.theme.space.marginMobile}vw;
    padding-bottom: ${(props) => props.theme.space.marginMobile}vw;
  } */
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: flex;
    justify-content: center;
    margin-bottom: ${(props) => props.theme.space.marginDesktop * 3}vw;
  }
`

const StyledSwiper = styled.div`
  position: relative;
  padding: 4vw;
  overflow: hidden;

  .swiper-container {
    overflow: visible;
  }

  .swiper-container-horizontal > .swiper-scrollbar {
    display: none;
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    & .swiper-button-next {
      background-image: url('https://i.ibb.co/m6217K6/next-arrow.png');
      background-size: cover !important;
    }
    & .swiper-button-prev {
      background-image: url('https://i.ibb.co/b197fxc/prev-arrow.png');
      background-size: cover !important;
    }
  }

  & .swiper-button-next,
  & .swiper-button-prev {
    position: absolute;
    display: block;
    width: 10vw;
    height: 10vw;
    bottom: 0;

    &.swiper-button-disabled {
      opacity: 0;
      svg {
        fill: lightgray;
      }
    }

    &::after {
      display: block;
      font-size: 3vw;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      background-color: white;
      box-shadow: 0 5px 10px 18px white;
    }
  }

  & .swiper-button-prev {
    left: -4vw;
  }
  & .swiper-button-next {
    right: -4vw;
  }
`

const Slide = styled.div`
  width: fit-content !important;
  padding: 0 2vw 2vw;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-align: center;
  border-bottom: 1px solid
    ${(props) =>
      props.selected ? props.theme.colors.black : props.theme.colors.lightGrey};
`
const CollectionListItem = styled.li`
  position: relative;

  /* @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding: 0 2vw 2vw;

    letter-spacing: 0.05em;
    text-transform: uppercase;
    text-align: center;

    border-bottom: 1px solid
      ${(props) =>
    props.selected ? props.theme.colors.black : props.theme.colors.lightGrey};

    &.keen-slider__slide {
      min-width: fit-content !important;
    }
  } */

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: 0 ${(props) => props.theme.space.marginDesktop * 1.5}vw;

    &::after {
      content: '';
      width: 100%;
      display: block;
      position: absolute;
      border-bottom: ${(props) => props.theme.space.marginDesktop / 8}vw solid
        black;
      height: ${(props) => props.theme.space.marginDesktop / 2}vw;
      transform: scaleX(0);
      transition: transform 0.2s ease-out;
      transform-origin: left;
      backface-visibility: hidden;
      ${(props) => (props.selected ? 'transform: scaleX(1)' : '')};
    }
    &:hover {
      &::after {
        transform: scaleX(1);
      }
    }
  }
`

const CollectionListLink = styled(SiteLink)`
  font-family: ${(props) => props.theme.fontFamily.normal};
  font-size: 3vw;
  white-space: nowrap;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d20};
  }
`

export default CollectionSwitcherAlt
